import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import Multiselect from "multiselect-react-dropdown";
import { Row, Col, Spinner, Button } from "react-bootstrap";
import slider1 from "./../../images/slider1.png";
import MultiImageInput from "react-multiple-image-input";
import UseAddProduct from "../../CustomHooks/Products/UseAddProduct";
import { CompactPicker } from "react-color";
import { ToastContainer } from "react-toastify";


const AdminAddProductsComp = () => {
  const [
    loading,
    isPress,
    isValidate,
    images,
    onSelect,
    onRemove,
    setImages,
    productName,
    OnChangeProductName,
    productDescription,
    onChangeProductDescription,
    priceBeforeDiscount,
    onChangePriceBeforeDiscount,
    productprice,
    onChangeProductprice,
    categoryValue,
    onChangeCategoryValue,
    BrandValue,
    onChangeBrandValue,
    allCategories,
    allbrands,
    SubmitForm,
    onToggleColor,
    toggleColor,
    SaveColorValue,
    colors,
    deleteColor,
    options,
    qty,
    onChangeqty,
    multiselectRef,
    validateProductName,
    validateProductDescription,
    validateProductqty,
    validatePriceBeforeDiscount,
    validateProductprice
  ] = UseAddProduct();

  return (
    <div>
      <Row className="justify-content-start">
        <h3 className='fw-bold m-3  mt-5'>Add New Product</h3>
        <Col sm="8" className="m-3">
          <div className="pb-2"> Product Image </div>
          <MultiImageInput
            max={6}
            theme="light"
            images={images}
            setImages={setImages}
            allowCrop={false}
          />
          <input
            type="text"
            className="form-control d-block mt-3 px-3"
            placeholder="Product Name"
            value={productName}
            onChange={OnChangeProductName}
            onBlur={validateProductName}
          />
          <textarea
            className="form-control p-2 mt-3"
            rows="4"
            cols="50"
            placeholder="Product Description "
            value={productDescription}
            onChange={onChangeProductDescription}
            onBlur={validateProductDescription}
          />
          <input
            type="number"
            className="form-control d-block mt-3 px-3"
            placeholder="Quantity"
            value={qty}
            onChange={onChangeqty}
            onBlur={validateProductqty}
          />
          <input
            type="number"
            className="form-control d-block mt-3 px-3"
            placeholder="Price before discount"
            value={priceBeforeDiscount}
            onChange={onChangePriceBeforeDiscount}
            onBlur={validatePriceBeforeDiscount}
          />
          <input
            type="number"
            className="form-control d-block mt-3 px-3"
            placeholder="Price after discount"
            value={productprice}
            onChange={onChangeProductprice}
            onBlur={validateProductprice}
          />
          <select
            name="Category"
            id="Category"
            className="form-control mt-3 px-2 "
            value={categoryValue}
            onChange={onChangeCategoryValue}          >
            <option value="0"> choose category name </option>
            {allCategories && allCategories.length >= 1
              ? allCategories.map((item, index) => {
                return <option value={item._id} key={index}> {item.name}</option>;
              })
              : null}
          </select>

          {/* <Multiselect
            className="mt-2 text-end"
            placeholder="Choose SubCategory "
            ref={multiselectRef}
            options={options}
            onSelect={onSelect}
            onRemove={onRemove}
            displayValue="name"
            style={{ color: "red" }}
          /> */}


          <select
            name="brand"
            id="brand"
            className="form-control mt-3 px-2 "
            value={BrandValue}
            onChange={onChangeBrandValue}          >
            <option value="0">Choose Brand Name</option>
            {allbrands && allbrands.length >= 1
              ? allbrands.map((item, index) => {
                return (
                  <option key={index} value={item._id}>
                    {item.name}
                  </option>
                );
              })
              : null}
          </select>

          <div className="my-3"> Product Colors </div>
          <div className="d-flex align-items-center">
            {colors
              ? colors.map((item, index) => {
                return (
                  <div className="d-flex flex-column me-2">
                    <div
                      key={index}
                      className="mt-1 remove-button"
                      style={{ backgroundColor: item }}
                    >
                    </div>
                    <Button className="remove-button rounded-0" variant="danger" onClick={() => deleteColor(item)}>Remove</Button>
                  </div>
                );
              })
              : null}
            <FaPlus onClick={onToggleColor} className="pointer-cursor fw-bold fs-20" />
            {toggleColor === true ? (
              <CompactPicker onChange={SaveColorValue} />
            ) : null}
          </div>
        </Col>
      </Row>
      <Row>
        <Col sm="8" className="d-flex justify-content-end">
          <button className="action-button d-inline mt-2  btn text-white dark-bg mb-5" onClick={SubmitForm} disabled={!isValidate}>
            {isPress ? loading ? (<Spinner animation="border" variant="light" />) : (<span>Save</span>) : <span>Save</span>}
          </button>
        </Col>
      </Row>
      <ToastContainer limit={3} />
    </div>
  );
};

export default AdminAddProductsComp;
